import React from "react";
import Spinner from "components/Library/Spinner";

import styles from "./StreamSpinner.css";

export default function StreamSpinner() {
  return (
    <div className={styles.root}>
      <Spinner />
    </div>
  );
}
